module.exports = __webpack_public_path__ + "img/kiwoom_main_right2.f24c5ff6.png";